import React from "react";

export default function MailboxTable({ mailboxes, onEdit, onDelete, onSendEmail }) {
  if (!mailboxes.length) return <p>No mailboxes found.</p>;

  return (
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          <th style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>#</th>
          <th style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>Tenant Name</th>
          <th style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>Tenant Email</th>
          <th style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>hasMail</th>
          <th style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {mailboxes.map((mb) => (
          <tr key={mb.id}>
            <td>{mb.number}</td>
            <td>{mb.tenant?.name || "-"}</td>
            <td>{mb.tenant?.email || "-"}</td>
            <td>{mb.hasMail ? "Yes" : "No"}</td>
            <td>
              <button onClick={() => onEdit(mb)}>Edit</button>
              <button onClick={() => onSendEmail(mb.id)}>
                Send Email
              </button>
              <button
                onClick={() => {
                  if (window.confirm("Delete this mailbox?")) onDelete(mb.id);
                }}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
